module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_9.82a1e064.jpg";